import React from "react";

// Fournisseurs sociaux RÉELLEMENT disponibles.
// Google : actif (Emergent-managed Google Auth).
// Apple / Facebook / Instagram : affichés UNIQUEMENT quand l'app OAuth correspondante est
// réellement configurée (aucun bouton factice tant que ce n'est pas branché — conforme à la
// consigne : "Ne jamais créer de fausse connexion visuelle non fonctionnelle").
const PROVIDERS = {
  apple: (process.env.REACT_APP_AUTH_APPLE || "").toLowerCase() === "true",
  facebook: (process.env.REACT_APP_AUTH_FACEBOOK || "").toLowerCase() === "true",
  instagram: (process.env.REACT_APP_AUTH_INSTAGRAM || "").toLowerCase() === "true",
};

export const AuthSocial = ({ redirectPath = "/mon-compte", dividerLabel = "OU CONTINUER AVEC", className = "" }) => {
  const googleLogin = () => {
    // NE PAS coder l'URL en dur ni ajouter de fallback/redirect : cela casse l'auth Emergent.
    const redirectUrl = window.location.origin + redirectPath;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className={`space-y-3 ${className}`} data-testid="auth-social">
      <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-zinc-500">
        <div className="flex-1 h-px bg-white/10" /> {dividerLabel} <div className="flex-1 h-px bg-white/10" />
      </div>

      <button
        type="button"
        onClick={googleLogin}
        data-testid="auth-google"
        className="w-full h-11 flex items-center justify-center gap-3 bg-white text-gray-900 border border-gray-300 rounded-xl font-medium text-sm hover:bg-gray-100 transition-colors shadow-sm"
      >
        <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continuer avec Google
      </button>

      {PROVIDERS.apple && (
        <button type="button" data-testid="auth-apple" className="w-full h-11 flex items-center justify-center gap-2 bg-black text-white border border-white/15 rounded-xl text-sm font-medium hover:bg-zinc-900 transition-colors">
           Continuer avec Apple
        </button>
      )}
      {PROVIDERS.facebook && (
        <button type="button" data-testid="auth-facebook" className="w-full h-11 flex items-center justify-center gap-2 bg-[#1877F2] text-white rounded-xl text-sm font-medium hover:brightness-110 transition">
          Continuer avec Facebook
        </button>
      )}
      {PROVIDERS.instagram && (
        <button type="button" data-testid="auth-instagram" className="w-full h-11 flex items-center justify-center gap-2 text-white rounded-xl text-sm font-medium transition" style={{ background: "linear-gradient(90deg,#833AB4,#E1306C,#F77737)" }}>
          Continuer avec Instagram
        </button>
      )}
    </div>
  );
};

export default AuthSocial;
